import React from "react";
import { PageSeo } from "../components/PageSeo";
import { Hero } from "../components/Hero";
import { HighlightSections } from "../components/HighlightSections";
import { AboutSection } from "../components/AboutSection";
import { ReviewsSection } from "../components/ReviewsSection";

export function HomePage() {
  return (
    <>
      <PageSeo
        title="RESTORAN KRČMA | Restoran, banket sala i prenoćište u Kragujevcu"
        description="RESTORAN KRČMA u Kragujevcu nudi domaću kuhinju, banket salu za proslave i prenoćište na jednoj lokaciji."
        keywords="restoran Kragujevac, banket sala Kragujevac, prenoćište Kragujevac, restoran Krčma"
        path="/"
      />
      <Hero />
      <HighlightSections />
      <AboutSection />
      <ReviewsSection />
    </>
  );
}

